import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { IBlog } from "../../Blog";
import {
  deleteReq,
  formatAxiosErrorMessage,
  get,
  putOrThrow,
} from "../../../../_api";
import { BlogForm } from "../BlogForm/BlogForm";
import {
  Alert,
  Button,
  Container,
  Group,
  Stack,
  Text,
  Title,
} from "@mantine/core";

export const EditArticle: React.FC = () => {
  const history = useHistory();
  const params = useParams<{ id: string }>();

  const [blog, setBlog] = useState<IBlog>();
  const [submitError, setSubmitError] = useState<string | null>(null);

  useEffect(() => {
    get(`blog/ids/${params.id}`).then((res) => setBlog(res));
  }, [params.id]);

  const onDelete = async (id: string) => {
    const conf = window.confirm(
      "Czy na pewno chcesz usunąć? Tej operacji nie można cofnąć."
    );
    if (conf) {
      await deleteReq(`blog/${id}`);
      history.push("/blog");
    }
  };
  return (
    <Container size="md" py="xl" pb={250}>
      <Stack gap="lg">
        <Title order={1}>Edytuj artykuł</Title>
        {submitError ? (
          <Alert
            color="red"
            variant="filled"
            title="Nie zapisano zmian"
            withCloseButton
            onClose={() => setSubmitError(null)}
            mb="md"
            style={{ position: "sticky", top: 0, zIndex: 200 }}
          >
            <Text size="sm" c="white" style={{ whiteSpace: "pre-wrap" }}>
              {submitError}
            </Text>
          </Alert>
        ) : null}
        <BlogForm
          blog={blog}
          onSubmit={async (values) => {
            setSubmitError(null);
            try {
              const res = await putOrThrow(`blog/${params.id}`, values);
              if (res) {
                history.push("/blog");
              }
            } catch (e) {
              setSubmitError(formatAxiosErrorMessage(e));
            }
          }}
        />
        <Group
          justify="flex-end"
          mt="xl"
          pt="lg"
          style={{ borderTop: "1px solid var(--mantine-color-gray-3)" }}
        >
          <Button
            variant="light"
            color="red"
            size="sm"
            radius="md"
            onClick={() => blog?._id && onDelete(blog._id)}
          >
            Usuń
          </Button>
        </Group>
      </Stack>
    </Container>
  );
};
